import React, {FC} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import styles from './AppHeader.css';

export const AppHeader: FC = () => {
	const t = useLocalizer();

	return (
		<header className={styles.root}>
			<div className={styles.logoLine}>
				<a className={styles.logo} href='/' aria-label={t('mainPageLabel')} />
			</div>
			<h1 className={styles.title}>{t('mainTitle')}</h1>
			<h2 className={styles.subtitle}>
				{t('mainIntro')}
				<br />
				{t('mainHint', {domain: DOMAIN_NAME})}
			</h2>
		</header>
	);
};

AppHeader.displayName = 'AppHeader';
